import React, { FC } from 'react';
import { DynamicFieldProps } from 'src/components/shared/molecules/dynamicField/types';
import { TimeManager } from 'src/utils/src/shared/TimeManager';
import { UiInputNormal } from 'src/components/shared/atoms/uiInputs/uiInputNormal/UiInputNormal';
import { NumberManager } from 'src/utils/src/shared/NumberManager';
import { UiContainerInputsNormal } from 'src/components/shared/atoms/uiLayout/uiContainerInputsNormal/UiContainerInputsNormal';

export const DynamicNumber: FC<DynamicFieldProps> = ({
    nazwa,
    przeliczanie_minut_i_godzin,
    field,
    isDisabledLabel
}) => {
    const data = {
        formattedValue:
            NumberManager.countDecimals(field.value) > 3
                ? String(Number(field.value).toFixed(3))
                : String(field.value)
    };

    const ubdateTimeDecimal = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (isNaN(Number(e.target.value))) return;
        field.onChange(e.target.value);
    };

    const ubdateTimeNormal = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = TimeManager.setMinutesAbsoluteToHour(Number(e.target.value));
        field.onChange(String(value.toFixed(3)));
    };

    if (przeliczanie_minut_i_godzin === 't') {
        return (
            <UiContainerInputsNormal>
                <UiInputNormal
                    label={isDisabledLabel ? '' : nazwa}
                    onChange={ubdateTimeDecimal}
                    value={data.formattedValue}
                />
                <UiInputNormal
                    label={isDisabledLabel ? '' : 'Poświęcony czas w min.'}
                    onChange={ubdateTimeNormal}
                    value={TimeManager.devideHoursToAbsoluteMinutes(Number(data.formattedValue))}
                />
            </UiContainerInputsNormal>
        );
    }

    return <UiInputNormal label={nazwa} onchange={ubdateTimeDecimal} value={data.formattedValue} />;
};
